/**
 * LazyLoadBackground
 *
 * @since 1.0.0
 */
export default () => {
  const elements = document.querySelectorAll('.js-lazy-load-background')
  if (!elements) return
  ;[...elements].forEach(el => {
    el.classList.add('background--is-loaded')
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/LazyLoadBackground.js